import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Input from 'components/Input'
import Button from 'components/Button'
import { LOGIN_PATH } from 'routing/constants'
import validatorEmail from 'validators/email'
import { requestUserResetPassword } from 'api/user'
import { showErrorToast, showSuccessToast } from 'utils/toast'
import Container from '../../components/Container'
import Row from 'components/Row'
import Col from 'components/Col'

import {
  ResetPasswordFooterText,
  ResetPasswordFooterWrapper,
  ResetPasswordTitle,
  ResetPasswordWrapper, StyledLink
} from './style'



const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState({
    field: '',
    error: ''
  })

  const isFormValid = () => {
    if (!email.length) {
      setError({ field: 'email', error: 'pleaseEnterYourEmail' })
      return false
    }

    if (!validatorEmail(email)) {
      setError({ field: 'email', error: 'emailIsInvalid' })
      return false
    }
    setError({ field: '', error: '' })
    return true
  }

  const emailHandler = (e) => {
    setEmail(e.target.value)
  }

  const submitForm = () => {
    if (!isFormValid()) {
      return
    }
    setIsSubmitting(true)
    setEmail('')
    try {
      const response = requestUserResetPassword({ email })
      if (response.error) {
        showErrorToast(<FormattedMessage id={response.error} />, 'showBorder')
      } else {
        showSuccessToast(<FormattedMessage id='resetPasswordSuccessful' />, 'showBorder')
      }
    } catch (e) {
      showErrorToast(<FormattedMessage id='somethingWentWrong' />, 'showBorder')
    }
    setIsSubmitting(false)
  }

  return (
    <>
      <Container>
        <Row>
          <Col md={8} mdOffset={2} >
            <ResetPasswordWrapper>
              <ResetPasswordTitle data-test='legend'>
                <FormattedMessage id='resetPassword' />
              </ResetPasswordTitle>
              <Input
                placeholder='Enter your email'
                value={email}
                onChange={emailHandler}
                field='email'
                margin='32px 0 0 0'
                error={error}
              />
              <Button isPending={isSubmitting} onClick={submitForm} width='100%' type='primary'>
                <FormattedMessage id='resetPassword' />
              </Button>
              <ResetPasswordFooterWrapper data-test='remember-your-password'>
                <ResetPasswordFooterText data-test='label'>
                  <FormattedMessage id='rememberYourPassword' />
                </ResetPasswordFooterText>
                <ResetPasswordFooterText>
                  <StyledLink data-test='sign-in' to={LOGIN_PATH}>
                    <FormattedMessage id='signIn' />
                  </StyledLink>
                </ResetPasswordFooterText>
              </ResetPasswordFooterWrapper>
            </ResetPasswordWrapper>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ForgotPasswordPage
